// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.table td[data-v-716212c9]{\n    border-top: none;\n}\n", ""]);
// Exports
module.exports = exports;
